import React from 'react';
import { CheckSquare, Loader2, X } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Barre d'actions de masse — apparaît dès qu'une ligne est cochée.
 * Les actions sont fournies par l'onglet appelant : chaque onglet n'expose
 * que les actions cohérentes avec son métier (frais, classification…).
 */
export const BulkActionBar = ({
  count,
  total,
  label = 'ligne(s)',
  actions = [],
  busy = false,
  onSelectAll,
  onClear,
  testid = 'bulk-action-bar',
}) => {
  if (!count) return null;
  return (
    <div
      className="sticky top-0 z-20 flex flex-wrap items-center gap-2 rounded-xl border border-emerald-300 bg-emerald-50/95 px-3 py-2 shadow-sm backdrop-blur"
      data-testid={testid}
    >
      <CheckSquare className="h-4 w-4 text-emerald-700" />
      <span className="text-xs font-semibold text-emerald-900 tabular-nums" data-testid={`${testid}-count`}>
        {count} {label} sélectionnée(s)
      </span>
      {onSelectAll && total > count && (
        <button
          type="button" onClick={onSelectAll}
          className="text-xs font-medium text-emerald-700 underline underline-offset-2 hover:text-emerald-900"
          data-testid={`${testid}-select-all`}
        >
          Tout sélectionner ({total})
        </button>
      )}
      <div className="mx-1 h-4 w-px bg-emerald-300" />
      {actions.map((a) => (
        <Button
          key={a.key} size="sm" variant={a.variant || 'outline'} disabled={busy}
          onClick={() => a.onClick(count)}
          className={`h-7 text-xs ${a.className || ''}`}
          data-testid={`${testid}-${a.key}`}
        >
          {busy ? <Loader2 className="mr-1 h-3 w-3 animate-spin" /> : a.icon}
          {a.label}
        </Button>
      ))}
      <Button
        size="sm" variant="ghost" onClick={onClear} disabled={busy}
        className="ml-auto h-7 text-xs text-zinc-600"
        data-testid={`${testid}-clear`}
      >
        <X className="mr-1 h-3 w-3" /> Annuler
      </Button>
    </div>
  );
};

/** Confirmation au-delà du seuil choisi par le PM (20 lignes). */
export const BULK_CONFIRM_THRESHOLD = 20;

export const confirmBulk = (count, actionLabel) => {
  if (count < BULK_CONFIRM_THRESHOLD) return true;
  // eslint-disable-next-line no-alert
  return window.confirm(
    `${actionLabel} sur ${count} lignes d'un seul coup. Confirmer ?`
  );
};

export default BulkActionBar;
